import React from "react";

export const Badge = ({ children, type }: { children: React.ReactNode; type?: string }) => {
  const isGold = type === "gold";
  return (
    <span
      style={{
        background: isGold ? "#FEF3C7" : "#E0F2FE",
        border: `1px solid ${isGold ? "#F59E0B" : "#0284C7"}`,
        color: isGold ? "#92400E" : "#0369A1",
        padding: "0.35rem 0.85rem",
        borderRadius: "999px",
        fontSize: "0.825rem",
        fontWeight: 700,
        margin: "0 4px",
        display: "inline-flex",
        alignItems: "center",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      }}
    >
      {children}
    </span>
  );
};

export const Alert = ({ children, type = "info" }: { children: React.ReactNode; type?: "info" | "warning" | "tip" }) => {
  let bg = "rgba(37, 99, 235, 0.06)";
  let border = "rgba(37, 99, 235, 0.2)";
  let color = "#1e40af";
  let icon = "ℹ️";

  if (type === "warning") {
    bg = "rgba(234, 179, 8, 0.08)";
    border = "rgba(234, 179, 8, 0.3)";
    color = "#854d0e";
    icon = "⚠️";
  } else if (type === "tip") {
    bg = "rgba(22, 163, 74, 0.06)";
    border = "rgba(22, 163, 74, 0.2)";
    color = "#15803d";
    icon = "💡";
  }

  return (
    <div
      style={{
        borderRadius: "12px",
        padding: "1.25rem",
        margin: "1.5rem 0",
        display: "flex",
        gap: "1rem",
        alignItems: "flex-start",
        fontSize: "0.925rem",
        background: bg,
        border: `1px solid ${border}`,
        color: color,
      }}
    >
      <div style={{ fontSize: "1.3rem", lineHeight: 1 }}>{icon}</div>
      <div>{children}</div>
    </div>
  );
};

export const ImageContainer = ({ src, alt, children }: { src: string; alt?: string; children?: React.ReactNode }) => {
  return (
    <div
      style={{
        margin: "1.75rem 0",
        background: "#F5F1E6",
        border: "1px solid #E4DCC8",
        borderRadius: "12px",
        padding: "1rem",
        textAlign: "center",
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          maxWidth: "100%",
          height: "auto",
          borderRadius: "8px",
          boxShadow: "0 4px 14px rgba(0, 0, 0, 0.08)",
          border: "1px solid rgba(0, 0, 0, 0.06)",
        }}
      />
      {children && (
        <div
          style={{
            marginTop: "0.75rem",
            fontSize: "0.85rem",
            fontWeight: 600,
            color: "#5C625F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.4rem",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export const components = {
  Badge,
  Alert,
  ImageContainer,
};
